<div class="exclusive-benefits" #sectionElement>
  <!-- Indicador de dispositivo (solo para desarrollo) -->
  <div class="exclusive-benefits__device-indicator" style="position: fixed; top: 10px; right: 10px; background: rgba(0,0,0,0.8); color: white; padding: 5px 10px; border-radius: 5px; font-size: 12px; z-index: 1000;">
    Dispositivo: {{ deviceType }} ({{ getCurrentWidth() }}px)
  </div>

  <app-container>
    <div class="exclusive-benefits__header">
      <div class="exclusive-benefits__title-container">
        <h2 class="exclusive-benefits__title">¡Aprovecha beneficios exclusivos con Unipay!</h2>
        <p class="exclusive-benefits__subtitle">En tus supermercados favoritos Unimarc, Super 10 y Alvi</p>
      </div>
      <div class="exclusive-benefits__button-container">

        <a [routerLink]="'/beneficios'" class="exclusive-benefits__link"  >
          <span class="exclusive-benefits__button-content">

            Conoce más beneficios
          </span>
        </a>
      </div>
    </div>

    <!-- Fila 1: 4 Tarjetas -->
    <div class="exclusive-benefits__grid exclusive-benefits__grid--fila1" 
         *ngIf="shouldShowFila1()" 
         #fila1Element
         data-section-id="exclusive-benefits-fila1">
      <div *ngFor="let item of getFilteredFila1Items(); trackBy: trackByDiscountId" class="exclusive-benefits__card"
        [class.exclusive-benefits__card--hover]="hoveredCard === item.id" (mouseenter)="setHoveredCard(item.id)"
        (mouseleave)="setHoveredCard(null)" (click)="onCardClick(item)"
        [class.exclusive-benefits__card--clickable]="isCardClickable(item)">
        <img [src]="item.img" [alt]="item.titulo" class="exclusive-benefits__card-image"
          (error)="onImageError($event, fila1Items.indexOf(item))" />

      </div>
    </div>

    <!-- Loading Fila 1 -->
    <div class="exclusive-benefits__loading" *ngIf="isLoadingFila1">
      <p>Cargando beneficios de la fila 1...</p>
    </div>

    <!-- Error Fila 1 -->
    <div class="exclusive-benefits__error" *ngIf="errorFila1">
      <p>Error al cargar los beneficios de la fila 1</p>
    </div>

    <!-- Fila 2: 2 Tarjetas -->
    <div class="exclusive-benefits__grid exclusive-benefits__grid--fila2" 
         *ngIf="shouldShowFila2()" 
         #fila2Element
         data-section-id="exclusive-benefits-fila2">
      <div *ngFor="let item of getFilteredFila2Items(); trackBy: trackByDiscountId" class="exclusive-benefits__card-large"
        [class.exclusive-benefits__card--hover]="hoveredCard === item.id" (mouseenter)="setHoveredCard(item.id)"
        (mouseleave)="setHoveredCard(null)" (click)="onCardClick(item)"
        [class.exclusive-benefits__card--clickable]="isCardClickable(item)">
        <img [src]="item.img" [alt]="item.titulo" class="exclusive-benefits__card-image-large"
          (error)="onImageError($event, fila2Items.indexOf(item))" />


      </div>
    </div>

    <!-- Loading Fila 2 -->
    <div class="exclusive-benefits__loading" *ngIf="isLoadingFila2">
      <p>Cargando beneficios de la fila 2...</p>
    </div>

    <!-- Error Fila 2 -->
    <div class="exclusive-benefits__error" *ngIf="errorFila2">
      <p>Error al cargar los beneficios de la fila 2</p>
    </div>

    <!-- Fila 3: 4 Tarjetas -->
    <div class="exclusive-benefits__grid exclusive-benefits__grid--fila3" 
         *ngIf="shouldShowFila3()" 
         #fila3Element
         data-section-id="exclusive-benefits-fila3">
      <div *ngFor="let item of getFilteredFila3Items(); trackBy: trackByDiscountId" class="exclusive-benefits__card"
        [class.exclusive-benefits__card--hover]="hoveredCard === item.id" (mouseenter)="setHoveredCard(item.id)"
        (mouseleave)="setHoveredCard(null)" (click)="onCardClick(item)"
        [class.exclusive-benefits__card--clickable]="isCardClickable(item)">
        <img [src]="item.img" [alt]="item.titulo" class="exclusive-benefits__card-image"
          (error)="onImageError($event, fila3Items.indexOf(item))" />


      </div>
    </div>

    <!-- Loading Fila 3 -->
    <div class="exclusive-benefits__loading" *ngIf="isLoadingFila3">
      <p>Cargando beneficios de la fila 3...</p>
    </div>

    <!-- Error Fila 3 -->
    <div class="exclusive-benefits__error" *ngIf="errorFila3">
      <p>Error al cargar los beneficios de la fila 3</p>
    </div>

    <!-- Estado vacío si no hay datos -->
    <div class="exclusive-benefits__empty"
      *ngIf="getTotalItems() === 0 && !isLoadingFila1 && !isLoadingFila2 && !isLoadingFila3">
      <p>No hay beneficios disponibles en este momento</p>
    </div>
  </app-container>
</div>
